import { useAuth } from '../../auth/AuthContext'
import { SmartForm } from '../../components/formFields/Form'
 
export const MedicoPending = () => {
	 
	const {nombreCompleto} = useAuth()
 
	return (
		<SmartForm 
			title='Registro Pendiente de Revisión'
			onSubmit={() => {}}
		>
			<p>Hola, {nombreCompleto}</p>
			<p>Tu Registro está siendo revisado por nuestro equipo para su aprobación y para que puedas comenzar a utilizar la plataforma.</p>
			<p>Si surgiera alguna duda, nos comunicaremoscon vos a través de los datos de contacto que proporcionaste.</p>
			<p>Recibirás un correo electrónico con el resultado de la Revisión</p>
			<p>Gracias por tu interés en Kaiteki</p>
		</SmartForm>
	)
}
 
export const MedicoRechazado = () => {
	 
	const {nombreCompleto} = useAuth()
 
	return (
		<SmartForm 
			title='Registro No Aprobado'
			onSubmit={() => {}}
		>
			<p>Hola, Dr. {nombreCompleto}</p>
			<p>Gracias por tu interés en sumarte a Kaiteki Salud.</p>
			<p>Por el momento, tu registro no ha sido aprobado, en función de las necesidades actuales de la plataforma. Esto no implica una evaluación negativa de tu desempeño profesional.</p>
			<p>Tus datos quedarán registrados y podremos volver a contactarte más adelante si se abren nuevas instancias de incorporación.</p>
			<p>Gracias por tu tiempo y por el interés en Kaiteki.</p>
		</SmartForm>
	)
}